export default __webpack_public_path__ + "static/media/openingsmaller.f02ea770.png";